import { render } from "./OrdersAccounting.vue?vue&type=template&id=7df95c50&scoped=true"
import script from "./OrdersAccounting.vue?vue&type=script&lang=js"
export * from "./OrdersAccounting.vue?vue&type=script&lang=js"

import "./OrdersAccounting.vue?vue&type=style&index=0&id=7df95c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df95c50"]])

export default __exports__